import * as React from "react"

type Props = React.HTMLProps<HTMLAnchorElement> & {
    href: string
    className?: string
    children: React.ReactNode
}

/** For <a href="..." /> links that should be opened in new tab */
export const ABlank = (props: Props) => {
    const { href, className, children, ...restProps } = props
    return (
        <a href={href} className={className} target="_blank" rel="noreferrer" {...restProps}>
            {children}
        </a>
    )
}
